import React from "react";
import Layout from "src/components/layout/website/Layout";
import { SITE_SETTINGS } from "src/constants/common";

// TODO(legal): Replace SITE_SETTINGS.ADDRESS and the jurisdiction placeholder
// with real entity/address details once the business is registered, and have
// this reviewed by a lawyer before accepting payments.
const TermsPage: React.FC = () => {
  return (
    <Layout
      meta={{
        title: "Terms & Conditions — Invyntra",
        description: "The terms that govern use of the Invyntra platform.",
      }}
    >
      <div className="min-h-screen bg-white py-16 px-6 max-w-5xl mx-auto">
        <h1 className="text-3xl font-bold text-indigo-600 mb-2">
          Terms &amp; Conditions
        </h1>
        <p className="text-gray-500 text-sm mb-6">Last updated: [Date]</p>

        <p className="text-gray-600 mb-6">
          By creating an account or using Invyntra ("Service"), you agree to
          these terms. If you're using the Service on behalf of a business,
          you're confirming you have the authority to bind that business to
          these terms.
        </p>

        <h2 className="font-semibold text-lg text-gray-800 mt-8 mb-2">
          1. Accounts
        </h2>
        <ul className="list-disc ml-6 text-gray-600 space-y-2">
          <li>
            You're responsible for maintaining the confidentiality of your
            login credentials and for all activity under your account.
          </li>
          <li>
            You agree to provide accurate account and billing information.
          </li>
        </ul>

        <h2 className="font-semibold text-lg text-gray-800 mt-8 mb-2">
          2. Plans, trials &amp; billing
        </h2>
        <ul className="list-disc ml-6 text-gray-600 space-y-2">
          <li>
            New accounts may start on a free Trial plan with limited duration
            and usage limits, as described on our Pricing page.
          </li>
          <li>
            Paid plans are billed in advance for the plan's billing period.
            Prices and usage limits are as shown on the Pricing page at the
            time of purchase.
          </li>
          <li>
            We'll notify registered users of any pricing or feature changes
            to paid plans before they take effect.
          </li>
          <li>
            Refund and cancellation terms: [To be defined before accepting
            payments].
          </li>
        </ul>

        <h2 className="font-semibold text-lg text-gray-800 mt-8 mb-2">
          3. Your data
        </h2>
        <p className="text-gray-600 mb-6">
          You own the business data you enter into Invyntra (products, stock,
          orders, customers, suppliers, and similar records). We access it
          only to provide and support the Service, as described in our{" "}
          <a href="/privacy" className="text-indigo-600">
            Privacy Policy
          </a>
          .
        </p>

        <h2 className="font-semibold text-lg text-gray-800 mt-8 mb-2">
          4. Acceptable use
        </h2>
        <p className="text-gray-600 mb-6">
          You agree not to misuse the Service — including attempting to
          disrupt it, access other tenants' data without authorization, or
          use it for unlawful purposes.
        </p>

        <h2 className="font-semibold text-lg text-gray-800 mt-8 mb-2">
          5. Service availability
        </h2>
        <p className="text-gray-600 mb-6">
          We're an early-access product and aim for high reliability, but
          don't currently guarantee a specific uptime. We'll communicate any
          planned downtime where possible.
        </p>

        <h2 className="font-semibold text-lg text-gray-800 mt-8 mb-2">
          6. Termination
        </h2>
        <p className="text-gray-600 mb-6">
          You may stop using the Service and close your account at any time.
          We may suspend or terminate accounts that violate these terms, with
          notice where practical.
        </p>

        <h2 className="font-semibold text-lg text-gray-800 mt-8 mb-2">
          7. Governing law
        </h2>
        <p className="text-gray-600 mb-6">
          These terms are governed by the laws of [Jurisdiction, e.g. India],
          without regard to conflict of law principles.
        </p>

        <h2 className="font-semibold text-lg text-gray-800 mt-8 mb-2">
          8. Changes to these terms
        </h2>
        <p className="text-gray-600 mb-6">
          We may update these terms as the product evolves. Continued use of
          the Service after changes take effect means you accept the updated
          terms.
        </p>

        <h2 className="font-semibold text-lg text-gray-800 mt-8 mb-2">
          9. Contact
        </h2>
        <p className="text-gray-600">
          Questions about these terms can be sent to{" "}
          <span className="text-indigo-600">
            {SITE_SETTINGS.CONTACT_EMAIL}
          </span>
          .
          <br />
          Registered business address: {SITE_SETTINGS.ADDRESS}
        </p>
      </div>
    </Layout>
  );
};

export default TermsPage;
